import { render } from "./PredictionsPage.vue?vue&type=template&id=755b0af4&scoped=true"
import script from "./PredictionsPage.vue?vue&type=script&lang=js"
export * from "./PredictionsPage.vue?vue&type=script&lang=js"

import "./PredictionsPage.vue?vue&type=style&index=0&id=755b0af4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-755b0af4"]])

export default __exports__